module.exports = __webpack_public_path__ + "img/product8p.b8ae5333.png";